
  <div id="sumsub-websdk-continue">

  </div>

<script>

import {querystring} from 'svelte-spa-router'

import {launchContinue} from "../sumsub";
import SumsubContinue from '../components/SumsubContinue.svelte';
import { onMount } from "svelte";

export let params



onMount(() => {

  launchContinue(params.jwt)

})


</script>

<style>
</style>
